export default {
  blank: () => import("/home/anh/project/outsource/alobacsi/clinic booking/user-web-app/src/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/anh/project/outsource/alobacsi/clinic booking/user-web-app/src/layouts/default.vue").then(m => m.default || m)
}